export const apiAuthorizationConfig = {
    endpoint: '/',
    applicationName: 'SkillshubImpacts',
};